import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/ayak-terlemesi-icin-botoks-tedavisi/page.tsx");
